import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=27a0cc86&scoped=true&"
import script from "./DetailsModal.vue?vue&type=script&lang=js&"
export * from "./DetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=27a0cc86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0cc86",
  null
  
)

export default component.exports